/* eslint-disable no-func-assign */
/* eslint-disable no-unreachable */
/* eslint-disable no-constant-condition */
/* eslint-disable no-useless-escape */
/* eslint-disable no-redeclare */
/* eslint-disable no-extend-native */
/* eslint-disable no-undef-init */
/* eslint-disable no-unused-vars */
/* eslint-disable no-cond-assign */
/* eslint-disable one-var */
/* eslint-disable eqeqeq */
/* eslint-disable no-undef */
/* eslint-disable camelcase */
import com from './common'
import wx from 'weixin-js-sdk'
import { customRequestAjax } from '@/axiosApi/index'
import $ajax from '@/axiosApi/ajax_config'
/**不要再这里引入文件，会影响文件里的arg取不到值 */
// import $App from './app_interactive'

import waptoken from './wapid'
import Vue from 'vue'
import { Toast } from 'vant'

Vue.use(Toast)
// var appkey = 'lmxuhwagx94xd'
/** ***不要它*****/
// setCookie('wxmalltoken', '000LTFQ00040G1yFUic0PuKS12lFzVoxqv000')
/********/

const env_config = process.env.ENV_CONFIG
const path_config = require('../../config/path_' + env_config + '.js').default

var basepath = path_config.basepath,
  buriedpointpath = path_config.buriedpointpath,
  downloadpath = path_config.downloadpath,
  downloadshoppath = path_config.downloadshoppath,
  datacenterpath = path_config.datacenterpath,
  // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
  cosuploadpath = path_config.cosuploadpath,
  cosaccesspath = path_config.cosaccesspath
// 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End

console.log(process.env.NODE_ENV)
if (getQueryString('scene')) {
  sessionStorage.setItem('scene', getQueryString('scene'))
}
var isWx =
  getQueryString('pt') && getQueryString('pt') == 'app'
    ? 2
    : getQueryString('pt') && getQueryString('pt') == 'ckapp'
    ? 5
    : isWeixin() && getQueryString('pt') && getQueryString('pt') == 'xcx'
    ? 4
    : isWeixin()
    ? 1
    : 3
var appid
if (getQueryString('pt') == 'jzdzwap') {
  setCookie('wxmalltoken', getQueryString('waptoken'))
  appid = getCookie('wxmalltoken')
} else {
  appid =
    (getQueryString('pt') == 'app' ||
      getQueryString('pt') == 'ckapp' ||
      getQueryString('pt') == 'xcx') &&
    getQueryString('token')
      ? getQueryString('token')
      : getCookie('wxmalltoken')
      ? getCookie('wxmalltoken')
      : waptoken
      ? waptoken.waptoken
      : ''
}
var wxAjaxData =
  '?appid=' +
  isWx +
  '&tn=' +
  new Date().getTime() +
  '&token=' +
  appid +
  '&source=wx&sign=' +
  new Date().getTime() +
  (exclusiveidFn() ? '&exclusiveid=' + exclusiveidFn() : '') +
  (meetingidFn() ? '&meetingid=' + meetingidFn() : '') +
  pointParams('&')

var sharetitle = '创客云商—让人们轻松触达科技带来的美好！'
var sharedesc = '精选好物等你来领，呼朋唤友燥起来'
var shareimg = basepath + 'static/images/logo.png'
var webview_data = null // webview_data.js参数

// 微信字体放大缩小对html页面布局错乱问题
// if (typeof WeixinJSBridge == 'object' && typeof WeixinJSBridge.invoke == 'function') {
//   handleFontSize()
// } else {
//   if (document.addEventListener) {
//     document.addEventListener('WeixinJSBridgeReady', handleFontSize, false)
//   } else if (document.attachEvent) {
//     //IE浏览器，非W3C规范
//     document.attachEvent('onWeixinJSBridgeReady', handleFontSize)
//   }
// }
// function handleFontSize() {
//   // 设置网页字体为默认大小
//   WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 })
//   // 重写设置网页字体大小的事件
//   WeixinJSBridge.on('menu:setfont', function() {
//     WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 })
//   })
// }
let $App = {}
try {
  $App = require('./app_interactive').default
} catch (e) {}

function isWeixin() {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}

function wxConfig(URL) {
  var url = $ajax.getwxSignPhoto_URL + '?reurl=' + encodeURIComponent(URL)
  customRequestAjax(url).then(function (res) {
    if (res.data.code === 200) {
      wx.config({
        debug: false,
        appId: res.data.appid,
        timestamp: res.data.timestamp,
        nonceStr: res.data.noncestr,
        signature: res.data.signature,
        jsApiList: [
          'checkJsApi',
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'chooseImage',
          'uploadImage',
          'getLocalImgData',
          'previewImage',
          'downloadImage',
          'hideMenuItems',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'onMenuShareQZone',
          'wx-open-launch-weapp',
          'getLocation',
          'openLocation',
          'wx-open-launch-app',
          'updateAppMessageShareData',
          'updateTimelineShareData'
        ],
        openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app']
      })
    }
  })
}

var weChatAuthorization = function () {
  if (
    (getCookie('wxmalltoken') === null || getCookie('wxmalltoken') === '') &&
    getQueryString('pt') != 'xcx'
  ) {
    sessionStorage.clear()
    localStorage.clear()
    clearAllCookie()
    if (getQueryString('emptybottle') == 'emptybottle') {
      // 重定向到当前页
      let url = window.location.href,
        base = new Base64()

      if (getQueryString('type') == 'skinAnalysis') {
        url =
          url.indexOf('?') != -1
            ? basepath + 'skinAnalysis' + url.substr(url.indexOf('?'))
            : basepath + 'skinAnalysis'
      }
      let weChatUrl =
        basepath +
        $ajax.index_URL +
        '?appid=' +
        isWx +
        '&tn=' +
        new Date().getTime() +
        '&sign=' +
        new Date().getTime() +
        (exclusiveidFn() ? '&exclusiveid=' + exclusiveidFn() : '') +
        (meetingidFn() ? '&meetingid=' + meetingidFn() : '') +
        '&path=' +
        base.encode(url) +
        '&type=' +
        getQueryString('emptybottle') +
        pointParams('&')
      location.href = weChatUrl
    } else {
      let weChatUrl =
        basepath +
        $ajax.index_URL +
        '?appid=' +
        isWx +
        '&tn=' +
        new Date().getTime() +
        '&sign=' +
        new Date().getTime() +
        (exclusiveidFn() ? '&exclusiveid=' + exclusiveidFn() : '') +
        (meetingidFn() ? '&meetingid=' + meetingidFn() : '') +
        pointParams('&')
      location.href = weChatUrl
    }
    // console.log('wxTokenhref', getCookie('wxmalltoken'))
  }
}

// 获取cookie
function getCookie(name) {
  var arr,
    reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')

  if ((arr = document.cookie.match(reg))) {
    return unescape(arr[2])
  } else {
    return null
  }
}

// 设置cookie
function setCookie(name, value, time) {
  var Days = 24 * 60 * 60 * 1000
  Days = time || Days
  var exp = new Date()
  exp.setTime(exp.getTime() + Days)
  document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString()
}

// 删除cookie
function deleteCookie(name) {
  var date = new Date()
  date.setTime(date.getTime() - 10000)
  document.cookie = name + '=v; expires=' + date.toGMTString()
}

function isApp() {
  if (isWx == 2 || isWx == 5 || isWx == 4) {
    if (getQueryString('v') == '4.0') {
      return (
        '&pt=' +
        getQueryString('pt') +
        '&token=' +
        getQueryString('token') +
        '&sign=' +
        getQueryString('sign') +
        '&v=' +
        getQueryString('v')
      )
    } else {
      return (
        '&pt=' +
        getQueryString('pt') +
        '&token=' +
        getQueryString('token') +
        '&sign=' +
        getQueryString('sign')
      )
    }
  }
  return ''
}

function goMini() {
  return '&pt=xcx' + '&token=' + appid + '&sign=' + new Date().getTime()
}

// 清除所有的缓存
function clearAllCookie() {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g)
  var date = new Date()
  date.setTime(date.getTime() - 10000)
  if (keys) {
    for (var i = keys.length; i--; ) {
      document.cookie = keys[i] + '=v; expires=' + date.toGMTString()
    }
  }
}

// 根据url获取url地址后所带参数
function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

// AI测肤适配小程序、app参数拼接
function parametersCombine() {
  if (isWx == 4 || isWx == 2 || isWx == 5) {
    return {
      pt: getQueryString('pt'),
      token: getQueryString('token'),
      sign: getQueryString('sign'),
      v: getQueryString('v')
    }
  } else {
    return {
      orgtype: getQueryString('orgtype')
    }
  }
}

/*
 * 浏览记录
 *
 * page: 'index', // 首页 index  账单yearbill
 * toappid: 1=微信 2=移动商城 3=wap 4=小程序 5创客APP 6产品手册
 * topage: 'index' // 首页 index  账单yearbill 直播列表 livelist 直播间 live
 * */
function browHistory(param, fn) {
  var url = $ajax.addUserLinkRecord_URL
  var data = {
    page: param.page,
    topage: param.topage,
    toappid: param.toappid,
    type: param.type
  }
  customRequestAjax
    .post(url, data)
    .then((res) => {
      if (typeof fn == 'function') {
        fn()
      }
    })
    .catch(() => {
      if (typeof fn == 'function') {
        fn()
      }
    })
}

function checkAgent() {
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    // 判断iPhone|iPad|iPod|iOS
    return 'ios'
  } else if (/(Android)/i.test(navigator.userAgent)) {
    // 判断Android
    // alert(navigator.userAgent);
    return 'android'
  } else if (/Harmony/i.test(navigator.userAgent)) {
    // HarmonyOS
    // alert(navigator.userAgent);
    return 'Harmony'
  } else {
    // pc
    return 'pc'
  }
}

// 加密
function encryption(code) {
  var c = String.fromCharCode(code.charCodeAt(0) + code.length)
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1))
  }
  return escape(c)
}

// 解密
function unencryption(code) {
  code = unescape(code)
  var c = String.fromCharCode(code.charCodeAt(0) - code.length)
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1))
  }
  return c
}

// 随机数
function random_string(n) {
  var num = Math.pow(10, n)
  return Math.ceil(Math.random() * num)
}
function fenxiang(parameter) {
  /* title, data, desc, acttitle, callback, imgx
   * parameter = {
   *   type: ''     跳转类型 index:首页/邀请好友，list:分类列表，detail:商品详情，ndo:皮肤测试,pt:拼团,flod:折上折
   *   title: ''    分享标题
   *   dataStr: ''  调用share接口所需参数
   *   desc: ''     分享内容
   *   imgx: ''     分享图片
   *   isnobound: 1 分享是否带绑定关系，传1不带关系
   * }
   */
  var isindex = 0,
    exclusiveid = exclusiveidFn(),
    pointParamsData = pointParams('&')
  if (!isWeixin()) {
    return
  }
  var url = $ajax.getCurrencyShare_URL
  customRequestAjax(url)
    .then((res) => {
      if (res.data.code == 200) {
        sharetitle = res.data.sharetitle ? res.data.sharetitle : sharetitle
        sharedesc = res.data.sharedesc ? res.data.sharedesc : sharedesc
        shareimg = res.data.shareimg ? res.data.shareimg : shareimg
        f()
      } else {
        f()
      }
    })
    .catch(() => {
      f()
    })
  function f() {
    if (
      (parameter.type &&
        parameter.type != undefined &&
        parameter.type != '' &&
        parameter.type != null) ||
      (parameter.dataStr &&
        parameter.dataStr != undefined &&
        parameter.dataStr != '' &&
        parameter.dataStr != null)
    ) {
      // 专属链接支持不可分享功能
      if (getQueryString('isshare') == 0) {
        isindex = 0
        parameter.dataStr = parameter.dataStr + '&isshare=' + getQueryString('isshare') + '&index=1'
      }
      if (getQueryString('isshare') == 0 && getQueryString('index') == 1) {
        isindex = 1
        parameter.type = 'index'
        parameter.dataStr = 'type=index'
        exclusiveid = ''
        pointParamsData = ''
      }
    } else {
      parameter.type = 'index'
      parameter.dataStr = 'type=index'
    }
    var link, img
    if (isWeixin()) {
      if (getQueryString('orgtype') == 'juzi' || getCookie('wxmalltoken')) {
        link =
          basepath +
          $ajax.share_URL +
          '?appid=' +
          isWx +
          '&tn=' +
          new Date().getTime() +
          '&token=' +
          appid +
          '&sign=' +
          new Date().getTime() +
          (exclusiveid ? '&exclusiveid=' + exclusiveid : '') +
          (meetingidFn() ? '&meetingid=' + meetingidFn() : '') +
          pointParamsData +
          '&' +
          parameter.dataStr
        // console.log('巨子', link)
      } else {
        weChatAuthorization()
      }
    } else {
      var wapid = waptoken.waptoken
      link =
        basepath +
        $ajax.share_URL +
        '?appid=' +
        isWx +
        '&tn=' +
        new Date().getTime() +
        '&token=' +
        wapid +
        '&sign=' +
        new Date().getTime() +
        (exclusiveid ? '&exclusiveid=' + exclusiveid : '') +
        (meetingidFn() ? '&meetingid=' + meetingidFn() : '') +
        pointParamsData +
        '&' +
        parameter.dataStr
    }

    if (parameter.isnobound == 1) {
      link =
        basepath +
        $ajax.share_URL +
        '?appid=' +
        isWx +
        '&tn=' +
        new Date().getTime() +
        '&sign=' +
        new Date().getTime() +
        (exclusiveid ? '&exclusiveid=' + exclusiveid : '') +
        (meetingidFn() ? '&meetingid=' + meetingidFn() : '') +
        pointParamsData +
        '&' +
        parameter.dataStr
    }

    if (
      !isindex &&
      !!parameter.imgx &&
      parameter.imgx != null &&
      parameter.imgx != '' &&
      parameter.imgx != undefined
    ) {
      img = parameter.imgx
    } else {
      img = shareimg
    }

    wx.ready(function () {
      wx.checkJsApi({
        jsApiList: ['wx-open-launch-app'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function (res) {
          console.log('可用')
        },
        fail: (err) => {
          console.log(err, '不可用')
        }
      })
      wx.hideMenuItems({
        menuList: ['menuItem:copyUrl'] // 要显示的菜单项，所有menu项见附录
      })
      var describe = ''
      if (
        !isindex &&
        parameter.desc != '' &&
        parameter.desc != null &&
        parameter.desc != undefined
      ) {
        describe = decodeURIComponent(parameter.desc)
      } else {
        describe = sharedesc
        // if (getCookie('ckc4_ckinfoname') != null && getCookie('ckc4_ckinfoname') != '' && getCookie('ckc4_ckinfoname') != undefined) {
        //   describe = unencryption(getCookie('ckc4_ckinfoname'))
        // } else {
        //   describe = '创客云商'
        // }
      }

      var fxtitle = ''
      if (
        !isindex &&
        parameter.title != '' &&
        parameter.title != null &&
        parameter.title != undefined
      ) {
        fxtitle = decodeURIComponent(parameter.title)
      } else {
        fxtitle = sharetitle
      }
      // alert(fxtitle, describe)
      wx.updateAppMessageShareData({
        title: fxtitle, // 分享标题
        desc: describe, // 分享描述
        link: link + '&source=wx', // 分享链接
        imgUrl: img, // 分享图标
        success: function () {
          // 分享方法执行成功回调
          if (parameter.successCallback && typeof parameter.successCallback == 'function') {
            parameter.successCallback()
          }
          console.log('分享方法执行成功')
        },
        cancel: function () {
          //   alert('已取消'); // 用户取消分享后执行的回调函数
        },
        fail: function (res) {
          //  alert(JSON.stringify(res));
        }
      })
      // alert(fxtitle, describe)
      wx.updateTimelineShareData({
        title: fxtitle, // 分享标题
        desc: describe, // 分享描述
        link: link + '&source=wx', // 分享链接
        imgUrl: img, // 分享图标
        success: function () {
          // 分享方法执行成功回调
          if (parameter.successCallback && typeof parameter.successCallback == 'function') {
            parameter.successCallback()
          }
          console.log('分享方法执行成功')
        },
        cancel: function () {
          //   alert('已取消'); // 用户取消分享后执行的回调函数
        },
        fail: function (res) {
          //  alert(JSON.stringify(res));
        }
      })
      // alert(fxtitle, describe)
      wx.onMenuShareAppMessage({
        title: fxtitle, // 分享标题
        desc: describe, // 分享描述
        link: link + '&source=wx', // 分享链接
        imgUrl: img, // 分享图标
        success: function () {
          //  alert('分享成功'); // 用户确认分享后执行的回调函数
          if (parameter.callback && typeof parameter.callback == 'function') {
            parameter.callback()
          }
          if (exclusiveidFn()) {
            customRequestAjax.post($ajax.saveExclusive_URL, { type: 2 }).then(function (res) {})
          }
          commonburiedPoint({
            data: { isshare: 1 }
          })
          console.log('分享成功')
        },
        cancel: function () {
          //   alert('已取消'); // 用户取消分享后执行的回调函数
        },
        fail: function (res) {
          //  alert(JSON.stringify(res));
        }
      })

      if (checkAgent() == 'ios') {
        // alert('ios')
        wx.onMenuShareTimeline({
          title: fxtitle,
          link: link + '&source=wx', // 分享链接
          imgUrl: img, // 分享图标
          success: function () {
            console.log('分享成功')
          },
          complete: function () {},
          trigger: function () {
            if (parameter.callback && typeof parameter.callback == 'function') {
              parameter.callback()
            }
            if (exclusiveidFn()) {
              customRequestAjax.post($ajax.saveExclusive_URL, { type: 2 }).then(function (res) {})
            }
            commonburiedPoint({
              data: { isshare: 1 }
            })
          }
        })
      } else {
        // alert('android')
        wx.onMenuShareTimeline({
          title: fxtitle,
          link: link + '&source=wx', // 分享链接
          imgUrl: img, // 分享图标
          success: function () {
            console.log('分享成功')
            if (parameter.callback && typeof parameter.callback == 'function') {
              parameter.callback()
            }
            if (exclusiveidFn()) {
              customRequestAjax.post($ajax.saveExclusive_URL, { type: 2 }).then(function (res) {})
            }
            commonburiedPoint({
              data: { isshare: 1 }
            })
          },
          complete: function () {}
        })
      }
      // link:  link + ((parameter.type == 'fhelp' || parameter.type == 'smallv') ? '&from=wx' : '&from=wap')
      wx.onMenuShareQQ({
        title: fxtitle, // 分享标题
        desc: describe, // 分享描述
        link: link + '&source=wap', // 分享链接
        imgUrl: img, // 分享图标
        success: function () {
          console.log('分享成功')
          if (parameter.callback && typeof parameter.callback == 'function') {
            parameter.callback()
          }
          if (exclusiveidFn()) {
            customRequestAjax.post($ajax.saveExclusive_URL, { type: 2 }).then(function (res) {})
          }
          commonburiedPoint({
            data: { isshare: 1 }
          })
        },
        cancel: function () {
          if (parameter.callback && typeof parameter.callback == 'function') {
            parameter.callback()
          }
          if (exclusiveidFn()) {
            customRequestAjax.post($ajax.saveExclusive_URL, { type: 2 }).then(function (res) {})
          }
          commonburiedPoint({
            data: { isshare: 1 }
          })
        }
      })
      // link:  link + ((parameter.type == 'fhelp' || parameter.type == 'smallv') ? '&from=wx' : '&from=wap')
      wx.onMenuShareWeibo({
        title: fxtitle, // 分享标题
        link: link + '&source=wap', // 分享链接
        imgUrl: img, // 分享图标
        success: function () {
          console.log('分享成功')
          if (parameter.callback && typeof parameter.callback == 'function') {
            parameter.callback()
          }
          if (exclusiveidFn()) {
            customRequestAjax.post($ajax.saveExclusive_URL, { type: 2 }).then(function (res) {})
          }
          commonburiedPoint({
            data: { isshare: 1 }
          })
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          Toast('分享失败')
          // 用户取消分享后执行的回调函数
        }
      })
      // link:  link + ((parameter.type == 'fhelp' || parameter.type == 'smallv') ? '&from=wx' : '&from=wap')
      wx.onMenuShareQZone({
        title: fxtitle, // 分享标题
        desc: describe, // 分享描述
        link: link + '&source=wap', // 分享链接
        imgUrl: img, // 分享图标
        success: function () {
          console.log('分享成功')
          if (parameter.callback && typeof parameter.callback == 'function') {
            parameter.callback()
          }
          if (exclusiveidFn()) {
            customRequestAjax.post($ajax.saveExclusive_URL, { type: 2 }).then(function (res) {})
          }
          commonburiedPoint({
            data: { isshare: 1 }
          })
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          Toast('分享失败')
          // 用户取消分享后执行的回调函数
        }
      })
    })
    wx.error(function (res) {
      console.log(res)
    })
  }
}

function kefu(o, card) {
  var my_ckid, my_smallname, my_head, me_id, me_realname
  var url = $ajax.getUserFromOpenid_URL
  customRequestAjax(url).then(function (res) {
    if (res.data.code == 200) {
      my_ckid = res.data.ckid
      my_smallname = res.data.smallname
      my_head = res.data.head
      me_id = res.data.id
      me_realname = res.data.realname
      localStorage.setItem(
        'userme',
        JSON.stringify({
          userId: res.data.id,
          head: res.data.head,
          name: res.data.smallname
        })
      )
      var action = [
        {
          actionType: 'to_group',
          optionId: '4',
          deciId: '45500a1b3fa54a1f898e7811f93d9d76'
        }
      ]
      if (res.data.isvip == 1) {
        my_smallname = my_smallname + '(35VIP)'
        action[0].deciId = 'd1b063b9952549efb03a9fb83f979652'
      } else if (res.data.isvip == 2) {
        my_smallname = my_smallname + '(50VIP)'
        action[0].deciId = '503316a985774391b36c28778b4fb857'
      } else if (res.data.isvip == 3) {
        my_smallname = my_smallname + '(非全员工)'
        action[0].deciId = '40d8c1ca623a47f7a03fbc43cd45c55c'
      } else {
        if (res.data.istg == 1) {
          my_smallname = my_smallname + '(客服托管)'
          action[0].deciId = '6c9d33dedb5d4266a7cc638afbe3cc63'
        }
      }
      var payload = JSON.stringify(action)

      if (my_ckid == 0 || my_ckid == 666 || o == 1 || res.data.istg == 1) {
        customRequestAjax($ajax.addTrusteeshipUserRecord_URL).then(function (res) {})
        setTimeout(function () {
          const params = {
            partnerId: me_id
          }
          window.location.href =
            'https://wpa1.qq.com/85jJZL0D?_type=wpa&auth=commonAuth&code=' +
            me_id +
            '&qidian_ex1=' +
            JSON.stringify(params) +
            (card ? '&' + card : '') +
            '&wpaShowItemId=123'
          // window.location.href =
          //   'https://ckysmall.sobot.com/chat/h5/v6/index.html?sysnum=b96b3e57c0814d9d987bd21efc7c5934&channelid=3&top_bar_flag=0&show_evaluate=1&customBtn=true' +
          //   '&color=aabbcc&powered=' +
          //   true +
          //   '&moduleType=3&artificial=' +
          //   false +
          //   '&lan=cn&partnerid=' +
          //   me_id +
          //   '&face=' +
          //   my_head +
          //   '&uname=' +
          //   my_smallname +
          //   '&transfer_action=' +
          //   payload +
          //   '&back=1&titleFlag=2&satDegree_A=' +
          //   true +
          //   '&anchor=' +
          //   true +
          //   '&autoExpand=' +
          //   true +
          //   (card ? '&' + card : '') +
          //   '&tel=' +
          //   res.data.tel +
          //   '&realname=' +
          //   me_realname
        }, 500)
      } else {
        localStorage.setItem(
          'conversation',
          JSON.stringify({
            img: my_head
          })
        )
        location.href = '../../../../static/wx/rongyunTest/bb/index.html'
      }
    }
  })
}
function qrcodeKefuLimits(source) {
  return new Promise((resolve) => {
    customRequestAjax($ajax.getUserConsultingDirection_URL).then((res) => {
      if (res.data.code == 200) {
        if (res.data.type == 1) {
          $App.argStaticLink('/static/wx/html/kefu/index.html?source=' + source)
        } else {
          resolve()
        }
      }
    })
  })
}
function Base64() {
  // private property
  var _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='

  // public method for encoding
  this.encode = function (input) {
    var output = ''
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4
    var i = 0
    input = _utf8_encode(input)
    while (i < input.length) {
      chr1 = input.charCodeAt(i++)
      chr2 = input.charCodeAt(i++)
      chr3 = input.charCodeAt(i++)
      enc1 = chr1 >> 2
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
      enc4 = chr3 & 63
      if (isNaN(chr2)) {
        enc3 = enc4 = 64
      } else if (isNaN(chr3)) {
        enc4 = 64
      }
      output =
        output +
        _keyStr.charAt(enc1) +
        _keyStr.charAt(enc2) +
        _keyStr.charAt(enc3) +
        _keyStr.charAt(enc4)
    }
    return output
  }

  // public method for decoding
  this.decode = function (input) {
    var output = ''
    var chr1, chr2, chr3
    var enc1, enc2, enc3, enc4
    var i = 0
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '')
    while (i < input.length) {
      enc1 = _keyStr.indexOf(input.charAt(i++))
      enc2 = _keyStr.indexOf(input.charAt(i++))
      enc3 = _keyStr.indexOf(input.charAt(i++))
      enc4 = _keyStr.indexOf(input.charAt(i++))
      chr1 = (enc1 << 2) | (enc2 >> 4)
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2)
      chr3 = ((enc3 & 3) << 6) | enc4
      output = output + String.fromCharCode(chr1)
      if (enc3 != 64) {
        output = output + String.fromCharCode(chr2)
      }
      if (enc4 != 64) {
        output = output + String.fromCharCode(chr3)
      }
    }
    output = _utf8_decode(output)
    return output
  }

  // private method for UTF-8 encoding
  var _utf8_encode = function (string) {
    string = string.replace(/\r\n/g, '\n')
    var utftext = ''
    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n)
      if (c < 128) {
        utftext += String.fromCharCode(c)
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode((c >> 6) | 192)
        utftext += String.fromCharCode((c & 63) | 128)
      } else {
        utftext += String.fromCharCode((c >> 12) | 224)
        utftext += String.fromCharCode(((c >> 6) & 63) | 128)
        utftext += String.fromCharCode((c & 63) | 128)
      }
    }
    return utftext
  }

  // private method for UTF-8 decoding
  var _utf8_decode = function (utftext) {
    var string = ''
    var i = 0
    var c = 0,
      c1 = 0,
      c2 = 0,
      c3
    while (i < utftext.length) {
      c = utftext.charCodeAt(i)
      if (c < 128) {
        string += String.fromCharCode(c)
        i++
      } else if (c > 191 && c < 224) {
        c2 = utftext.charCodeAt(i + 1)
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63))
        i += 2
      } else {
        c2 = utftext.charCodeAt(i + 1)
        c3 = utftext.charCodeAt(i + 2)
        string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63))
        i += 3
      }
    }
    return string
  }
}

function formateName(str) {
  return str.substr(0, 1) + new Array(str.length).join('*')
}

function formateMobile(str) {
  return str.substr(0, 3) + new Array(4).join('*') + str.substr(7, 11)
}

// h5复制文本到剪切板
function copyContentH5(content, cls) {
  var Url2 = document.getElementById(cls) // 要复制文字的节点
  if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
    // 区分iPhone设备
    window.getSelection().removeAllRanges() // 这段代码必须放在前面否则无效
    var range = document.createRange()
    // 选中需要复制的节点
    range.selectNode(Url2)
    // 执行选中元素
    window.getSelection().addRange(range)
    // 执行 copy 操作
    var successful = document.execCommand('copy')

    // 移除选中的元素
    window.getSelection().removeAllRanges()
    try {
      var msg = successful ? 'successful' : 'failed'
      // console.log('复制成功')
      Toast('复制成功')
    } catch (err) {
      // console.log('复制失败')
      Toast('复制失败')
    }
  } else {
    Url2.select() // 选择对象
    document.execCommand('Copy') // 执行浏览器复制命令
  }
}

// 解决iOS中键盘回落后留白问题@focus
function handleFocus(event) {
  // console.log(event)
  let e = event.currentTarget
  setTimeout(() => {
    e.scrollIntoView({
      block: 'start',
      behavior: 'smooth'
    })
  }, 300)
}
// 解决iOS中键盘回落后留白问题@blur
function handleblur(event) {
  let e = event.currentTarget
  setTimeout(() => {
    e.scrollIntoView({
      block: 'end',
      behavior: 'smooth'
    })
  }, 300)
  window.scrollTo(0, 0)
}

// 数组去重
function unique(arr) {
  if (!Array.isArray(arr)) {
    // console.log('type error!')
    return
  }
  var array = []
  for (var i = 0; i < arr.length; i++) {
    if (array.indexOf(arr[i]) === -1) {
      array.push(arr[i])
    }
  }
  return array
}
/**
 * JSON数组去重
 * @param: [array] json Array
 * @param: [string] 唯一的key名，根据此键名进行去重
 * */
function uniqueArray(array, key) {
  var result = [array[0]]
  for (var i = 1; i < array.length; i++) {
    var item = array[i]
    var repeat = false
    for (var j = 0; j < result.length; j++) {
      if (item[key] == result[j][key]) {
        repeat = true
        break
      }
    }
    if (!repeat) {
      result.push(item)
    }
  }
  return result
}
function appidFn() {
  if (getQueryString('appid') && getQueryString('appid') == 6) {
    sessionStorage.setItem('appid', getQueryString('appid'))
    return sessionStorage.getItem('appid')
  } else if (sessionStorage.getItem('appid') && sessionStorage.getItem('appid') == 6) {
    return sessionStorage.getItem('appid')
  } else {
    return -1
  }
}

function exclusiveidFn() {
  if (
    getQueryString('exclusiveid') &&
    getQueryString('exclusiveid') != 'undefined' &&
    getQueryString('exclusiveid') != 'null'
  ) {
    sessionStorage.setItem('exclusiveid', getQueryString('exclusiveid'))
    return sessionStorage.getItem('exclusiveid')
  } else if (
    sessionStorage.getItem('exclusiveid') &&
    sessionStorage.getItem('exclusiveid') != 'undefined' &&
    sessionStorage.getItem('exclusiveid') != 'null'
  ) {
    return sessionStorage.getItem('exclusiveid')
  } else {
    return ''
  }
}

// 线下会议营销会议id
function meetingidFn() {
  if (getQueryString('meetingid')) {
    sessionStorage.setItem('meetingid', getQueryString('meetingid'))
    return sessionStorage.getItem('meetingid')
  } else if (sessionStorage.getItem('meetingid')) {
    return sessionStorage.getItem('meetingid')
  } else {
    return ''
  }
}
// 公共参数获取
function publicParams(type) {
  if (getQueryString(type)) {
    sessionStorage.setItem(type, getQueryString(type))
    return sessionStorage.getItem(type)
  } else if (sessionStorage.getItem(type)) {
    return sessionStorage.getItem(type)
  } else {
    return ''
  }
}

function pointParams(joinParams, urlParams) {
  let join = joinParams || '',
    params = ''
  if (urlParams) join = urlParams.indexOf('?') >= 0 ? '&' : '?'
  if (
    getQueryString('userid') &&
    getQueryString('userid') != 'undefined' &&
    getQueryString('userid') != 'null'
  ) {
    sessionStorage.setItem('userid', getQueryString('userid'))
    params += join + 'userid=' + sessionStorage.getItem('userid')
  } else if (
    sessionStorage.getItem('userid') &&
    sessionStorage.getItem('userid') != 'undefined' &&
    sessionStorage.getItem('userid') != 'null'
  ) {
    params += join + 'userid=' + sessionStorage.getItem('userid')
  }

  if (
    getQueryString('shareOpenid') &&
    getQueryString('shareOpenid') != 'undefined' &&
    getQueryString('shareOpenid') != 'null'
  ) {
    sessionStorage.setItem('shareOpenid', getQueryString('shareOpenid'))
    params += (params == '' ? join : '&') + 'shareOpenid=' + sessionStorage.getItem('shareOpenid')
  } else if (
    sessionStorage.getItem('shareOpenid') &&
    sessionStorage.getItem('shareOpenid') != 'undefined' &&
    sessionStorage.getItem('shareOpenid') != 'null'
  ) {
    params += (params == '' ? join : '&') + 'shareOpenid=' + sessionStorage.getItem('shareOpenid')
  }

  /** 不分享的埋点参数 企微客服id传分享人埋点用 */
  if (
    getQueryString('sessionId') &&
    getQueryString('sessionId') != 'undefined' &&
    getQueryString('sessionId') != 'null'
  ) {
    sessionStorage.setItem('sessionId', getQueryString('sessionId'))
    params += (params == '' ? join : '&') + 'sessionId=' + sessionStorage.getItem('sessionId')
  } else if (
    sessionStorage.getItem('sessionId') &&
    sessionStorage.getItem('sessionId') != 'undefined' &&
    sessionStorage.getItem('sessionId') != 'null'
  ) {
    params += (params == '' ? join : '&') + 'sessionId=' + sessionStorage.getItem('sessionId')
  } else {
    sessionStorage.setItem('sessionId', com.randomString(32))
    params += (params == '' ? join : '&') + 'sessionId=' + sessionStorage.getItem('sessionId')
  }
  return params
}

function objectDecode(url) {
  let arr = Object.keys(url)
  // 判断传过来的字符串是不是空字符串判断传过来的字符串不是空字符串
  if (arr.length === 0) {
    return {}
  } else {
    url = decodeURIComponent(url)
    let obj = {}
    let keyvalue = []
    let key = ''
    let value = ''
    let paraString = url.substring(url.indexOf('?') + 1, url.length).split('&')
    for (let i in paraString) {
      if (paraString[i]) {
        keyvalue = paraString[i].split('=')
        key = keyvalue[0]
        value = keyvalue[1]
        obj[key] = value
      }
    }
    return obj
  }
}

function dateFn(date, type, istimestamp) {
  if (!date) return
  var dataStr = ''
  if (istimestamp == 1) {
    var year = new Date(date).getFullYear() // 年
    var month = new Date(date).getMonth() // 月
    var day = new Date(date).getDate() // 日
    var hours = new Date(date).getHours() // 时
    var min = new Date(date).getMinutes() // 分
    var second = new Date(date).getSeconds() // 秒
    dataStr =
      year +
      '-' +
      (month + 1 > 9 ? month + 1 : '0' + (month + 1)) +
      '-' +
      (day > 9 ? day : '0' + day) +
      ' ' +
      (hours > 9 ? hours : '0' + hours) +
      ':' +
      (min > 9 ? min : '0' + min) +
      ':' +
      (second > 9 ? second : '0' + second)
  } else {
    dataStr = date
  }
  var arr = dataStr.split(' ')
  var arrDateTime = arr[1].split(':')
  var arrDate = arr[0].split('-')
  if (type == 'datetime') {
    return (
      '<span><i>' +
      parseInt(arrDate[0]) +
      '</i> 年 <i>' +
      parseInt(arrDate[1]) +
      '</i> 月 <i>' +
      parseInt(arrDate[2]) +
      '</i> 日 ' +
      arrDateTime[0] +
      ':' +
      arrDateTime[1] +
      '</span>'
    )
  } else if (type == 'datetimestr') {
    // return parseInt(arrDate[0]) + '年' + parseInt(arrDate[1]) + '月' + parseInt(arrDate[2]) + '日' + arrDateTime[0] + ':' + arrDateTime[1]
    return (
      parseInt(arrDate[1]) +
      '月' +
      parseInt(arrDate[2]) +
      '日' +
      arrDateTime[0] +
      ':' +
      arrDateTime[1]
    )
  } else if (type == 'datestr') {
    return parseInt(arrDate[0]) + '年' + parseInt(arrDate[1]) + '月' + parseInt(arrDate[2]) + '日'
  } else if (type == 'datestr_md') {
    return parseInt(arrDate[1]) + '月' + parseInt(arrDate[2]) + '日'
  } else {
    return (
      '<span><i>' +
      parseInt(arrDate[0]) +
      '</i> 年 <i>' +
      parseInt(arrDate[1]) +
      '</i> 月 <i>' +
      parseInt(arrDate[2]) +
      '</i> 日</span>'
    )
  }
}

function requestSubscribeMessage(payAfter, fn, type, skuIds) {
  if (payAfter.length <= 0) {
    if (typeof fn == 'function') {
      fn()
    }
  } else {
    console.log(payAfter)
    if (payAfter.length > 0) {
      var url = $ajax.subscribeTrans_URL + '?pushmsgid=' + payAfter.join(',')
      if (type == 'detail' && skuIds.length > 0)
        url =
          $ajax.subscribeItem_URL +
          '?pushmsgid=' +
          payAfter.join(',') +
          '&skuid=' +
          skuIds.join(',')
      customRequestAjax(url)
        .then((res) => {
          console.log('subscribeTrans', res)
          if (typeof fn == 'function') {
            fn(res)
          }
        })
        .catch((err) => {
          if (typeof fn == 'function') {
            fn(err)
          }
        })
    }
  }
}

function dateStrFn(date) {
  var year = new Date(date).getFullYear() // 年
  var month = new Date(date).getMonth() // 月
  var day = new Date(date).getDate() // 日
  var hours = new Date(date).getHours() // 时
  var min = new Date(date).getMinutes() // 分
  var second = new Date(date).getSeconds() // 秒
  return (
    year +
    '-' +
    (month + 1 > 9 ? month + 1 : '0' + (month + 1)) +
    '-' +
    (day > 9 ? day : '0' + day) +
    ' ' +
    (hours > 9 ? hours : '0' + hours) +
    ':' +
    (min > 9 ? min : '0' + min) +
    ':' +
    (second > 9 ? second : '0' + second)
  )
}

// 920活动埋点
function buriedPoint(obj) {
  var url = buriedpointpath + 'ckysdatacenter/activity/save',
    isWoolparty = ''
  // if (sessionStorage.getItem('is_woolparty')) {
  //   isWoolparty = sessionStorage.getItem('is_woolparty') == 1 ? 'Y' : 'Z'
  // }
  var data = {
    actcode: obj.actcode ? obj.actcode : '20210920',
    behavior: isWoolparty + obj.behavior
  }
  if (obj.userfrom) data.userfrom = obj.userfrom
  customRequestAjax
    .post(url, data)
    .then(function (res) {
      if (obj && obj.callback && typeof obj.callback == 'function') obj.callback()
    })
    .catch(function () {
      if (obj && obj.callback && typeof obj.callback == 'function') obj.callback()
    })
}

// 普通用户埋点
function commonburiedPoint(obj) {
  // if (!sessionStorage.getItem('get_linkid')) return
  var url = buriedpointpath + 'ckysdatacenter/userbehavior/save'
  var data = obj && obj.data ? obj.data : {}
  var Timer = setInterval(function () {
    if (sessionStorage.getItem('getUserBehaviorLinkId_success')) {
      clearInterval(Timer)
      data.url = window.location.href
      if (
        data.isaddcart != 1 &&
        getQueryString('itemid') &&
        (window.location.href.indexOf('/productdetail') >= 0 ||
          window.location.href.indexOf('/ylactproduct') >= 0)
      )
        data.itemid = getQueryString('itemid')
      if (getQueryString('listType')) {
        data.listType = getQueryString('listType')
        if (
          data.listType == 2 &&
          window.location.href.indexOf('/orderdetails') >= 0 &&
          getQueryString('id')
        ) {
          data.orderid = getQueryString('id')
        }
      }
      if (sessionStorage.getItem('getUserBehaviorLinkId_success') == 1) {
        data.linkid = sessionStorage.getItem('get_linkid')
      } else if (sessionStorage.getItem('getUserBehaviorLinkId_success') == 2) {
        console.log('linkid获取失败')
      }
      if (sessionStorage.getItem('routefrom')) {
        let routefrom = JSON.parse(sessionStorage.getItem('routefrom'))
        data.scenepoint = routefrom.title
        data.scenedesc = routefrom.link
      } else if (getQueryString('scenepoint')) {
        data.scenepoint = decodeURIComponent(getQueryString('scenepoint'))
      }
      customRequestAjax
        .post(url, data)
        .then(function (res) {
          if (obj && obj.callback && typeof obj.callback == 'function') obj.callback()
        })
        .catch(function () {
          if (obj && obj.callback && typeof obj.callback == 'function') obj.callback()
        })
    }
  }, 100)
}
// 普通用户点击埋点
function clickburiedPoint(obj) {
  var url = buriedpointpath + 'ckysdatacenter/buttonclick/save'
  var data = obj && obj.data ? obj.data : {}
  if (obj.url) {
    url = buriedpointpath + obj.url
    if (obj.url.indexOf('community') >= 0 && sessionStorage.getItem('shareToken')) {
      data.sharetoken = sessionStorage.getItem('shareToken')
    }
  }
  var Timer = setInterval(function () {
    if (sessionStorage.getItem('getUserBehaviorLinkId_success')) {
      clearInterval(Timer)
      if (sessionStorage.getItem('getUserBehaviorLinkId_success') == 1) {
        data.linkid = sessionStorage.getItem('get_linkid')
      } else if (sessionStorage.getItem('getUserBehaviorLinkId_success') == 2) {
        console.log('linkid获取失败')
      }
      if (obj.url == 'ckysdatacenter/itemclick/save' && data.scenepoint == 'OTHERACT') {
        data.scenefrom = window.document.title
      }
      customRequestAjax
        .post(url, data)
        .then(function (res) {
          if (obj && obj.callback && typeof obj.callback == 'function') obj.callback()
        })
        .catch(function () {
          if (obj && obj.callback && typeof obj.callback == 'function') obj.callback()
        })
    }
  }, 100)
}
// 用户身份 920引流活动
function identity(obj) {
  var url = $ajax.getUserIdentity_DrainageDraw_URL
  customRequestAjax(url).then(function (res) {
    if (obj && obj.callback && typeof obj.callback == 'function') obj.callback(res)
  })
}

function getlinkidFn(obj) {
  var url = $ajax.getUserBehaviorLinkId_URL
  customRequestAjax(url)
    .then(function (res) {
      if (res.data.code == 200) {
        sessionStorage.setItem('get_linkid', res.data.linkid)
        sessionStorage.setItem('getUserBehaviorLinkId_success', 1)
        if (obj && obj.callback && typeof obj.callback == 'function') obj.callback(res)
      } else {
        sessionStorage.setItem('getUserBehaviorLinkId_success', 2)
      }
    })
    .catch(function () {
      sessionStorage.setItem('getUserBehaviorLinkId_success', 2)
    })
}

function clone(obj) {
  // Handle the 3 simple types, and null or undefined
  if (obj == null || typeof obj !== 'object') return obj
  // Handle Date
  if (obj instanceof Date) {
    var copy = new Date()
    copy.setTime(obj.getTime())
    return copy
  }
  // Handle Array
  if (obj instanceof Array) {
    var copy = []
    var len = obj.length
    for (var i = 0; i < len; ++i) {
      copy[i] = clone(obj[i])
    }
    return copy
  }
  // Handle Object
  if (obj instanceof Object) {
    var copy = {}
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr])
    }
    return copy
  }
  throw new Error("Unable to copy obj! Its type isn't supported.")
}

function cartNum(fn) {
  var url = $ajax.hasNewMsg_URL
  customRequestAjax(url).then((res) => {
    if (res.data.code == 200) {
      if (typeof fn == 'function') {
        fn(res.data.data.cartnum)
      }
    }
  })
}
function pageStatus(fn) {
  var url = $ajax.getUserNewPageInfo_URL
  customRequestAjax(url).then((res) => {
    if (res.data.code == 200) {
      if (typeof fn == 'function') {
        fn(res.data.isNewPage)
      }
    }
  })
}

async function ckeckgraphic(obj) {
  var url = $ajax.checkContent_URL,
    dataobj = obj
  let { data } = await customRequestAjax.post(url, dataobj)
  if (data.code == 200) {
    if (typeof dataobj.callback == 'function') dataobj.callback(data)
  } else {
    if (typeof dataobj.errcallback == 'function') dataobj.errcallback(data)
  }
}

function getVipLevel(val) {
  let vipImg = `/static/images/community/new-img/v${val}@2x.png`
  return vipImg
}

function popType(popNum, popup_ads, type, callback, callback_1, callback_2, timetype) {
  if (!localStorage.getItem(type + 'popFlag')) {
    localStorage.setItem(type + 'popFlag', 1)
  }
  if (sessionStorage.getItem(type + 'popFlagBool') == null) {
    sessionStorage.setItem(type + 'popFlagBool', 1)
  }
  if (sessionStorage.getItem(type + 'oncePopupFlag') == null) {
    // 只有每次打开商城首页才能触发的弹框（从其他页面返回首页不算）
    sessionStorage.setItem(type + 'oncePopupFlag', 1)
  }
  let popFlag = localStorage.getItem(type + 'popFlag')
  let normalPopIsShow = new Date(new Date().toLocaleDateString()).getTime()
  if (timetype == 'month') {
    normalPopIsShow = new Date(
      new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/1 00:00:00'
    ).getTime()
  }
  if (popup_ads && Object.keys(popup_ads).length > 0) {
    // console.log('普通弹框')
    if (+sessionStorage.getItem(type + 'popFlagBool')) {
      if (!localStorage.getItem(type + 'normalPopIsShow')) {
        if (sessionStorage.getItem(type + 'oncePopupFlag') == 1) {
          localStorage.setItem(type + 'normalPopIsShow', normalPopIsShow)
          if (typeof callback == 'function') {
            callback()
          } else if (typeof callback_1 == 'function') {
            callback_1()
          }
          localStorage.setItem(type + 'popFlag', +popFlag + 1)
          sessionStorage.setItem(type + 'popFlagBool', 0)
          sessionStorage.setItem(type + 'oncePopupFlag', 0)
        }
      } else {
        let oldDay = localStorage.getItem(type + 'normalPopIsShow')
        if (oldDay != normalPopIsShow) {
          if (sessionStorage.getItem(type + 'oncePopupFlag') == 1) {
            localStorage.setItem(type + 'popFlag', 1)
            localStorage.setItem(type + 'normalPopIsShow', normalPopIsShow)
            if (typeof callback == 'function') {
              callback()
            } else if (typeof callback_1 == 'function') {
              callback_1()
            }
            sessionStorage.setItem(type + 'popFlagBool', 0)
            sessionStorage.setItem(type + 'oncePopupFlag', 0)
          }
        } else {
          if (popFlag <= popNum) {
            if (sessionStorage.getItem(type + 'oncePopupFlag') == 1) {
              if (typeof callback == 'function') {
                callback()
              } else if (typeof callback_1 == 'function') {
                callback_1()
              }
              localStorage.setItem(type + 'popFlag', +popFlag + 1)
              sessionStorage.setItem(type + 'popFlagBool', 0)
              sessionStorage.setItem(type + 'oncePopupFlag', 0)
            }
          }
        }
      }
    }
  } else if (typeof callback_2 == 'function') {
    callback_2()
  }
}
function clearPopCache(type) {
  localStorage.removeItem(type + 'popFlag')
  sessionStorage.removeItem(type + 'popFlagBool')
  sessionStorage.removeItem(type + 'oncePopupFlag')
  localStorage.removeItem(type + 'normalPopIsShow')
}
function bannerClick(items, index, flowArea, _this, dataCollection, page, obj) {
  if (typeof dataCollection == 'function') {
    dataCollection()
  }
  _this.$clickburiedPoint({
    data: {
      buttonCode: flowArea,
      buttontext:
        obj && obj.point && obj.point.buttontext
          ? obj.point.buttontext +
            '-' +
            (obj.point.buttontext.indexOf(items.ad_title + '-') == 0 ? '' : items.ad_title)
          : items.ad_title
    },
    callback: () => {
      if (items.ad_type == 9) {
        $App.goIntegral()
        return
      } else if (items.ad_type == 10) {
        $App.goBestSellerList()
        return
      }
      switch (items.ad_type) {
        case '1': // 跳转链接
          if (items.ad_target == 'act') {
            // _this.moreHot()
          } else {
            if (items.ad_target.indexOf('power-luckdraw.html') >= 0) {
              _this.$buriedPoint({
                behavior: '100',
                userfrom: flowArea == '精选活动' ? 3 : 1
              })
            }
            var actid = parseInt(items.activityid) ? '?actid=' + items.activityid : ''
            if (items.ad_target.indexOf('anniversary-bill-big-swiper')) {
              sessionStorage.removeItem('anniversary-bill-pop-show')
            }
            let pathArr = items.ad_target.split('/')
            if (pathArr[pathArr.length - 1] == 'ylqrcode.html') {
              // 判断跳转链接是否是进入企微二维码页面
              _this.$customRequestAjax($ajax.getQrcode_URL).then((ok) => {
                if (ok.data.data.isRegularUser) {
                  // console.log('你不是普通用户')
                  _this.$toast('活动已结束')
                } else {
                  if (ok.data.data.qrcodePath == '') {
                    _this.$toast('您没有参与资格')
                  } else {
                    $App.argStaticLink(items.ad_target)
                  }
                }
              })
            } else {
              $App.argStaticLink(items.ad_target + actid)
            }
          }
          break
        case '2': // 商品分类
          if (items.ad_target == 0) {
            $App.goCategroy()
          } else {
            $App.goCategoryItem(
              {
                categoryid: items.father_class_id || '',
                categorysonid: items.ad_target,
                categorypagetitle: items.father_class_name || items.ad_title
              },
              _this
            )
          }
          break
        case '3': // 商品详情
          $App.goItemDetail(items.ad_target, {}, page || 'MAIN', {
            scenedesc: items.ad_title,
            scenefrom:
              obj && obj.point && obj.point.buttontext
                ? obj.point.buttontext +
                  '-' +
                  (obj.point.buttontext.indexOf(items.ad_title + '-') == 0 ? '' : items.ad_title)
                : items.ad_title
          })
          break
        case '4':
          $App.goIndex()
          break
        case '5':
          $App.goIndex()
          break
        case '7':
          if (isWeixin()) {
          } else {
            _this.$toast('请前往微信搜索小程序「创客云商可丽金官方」')
          }
          break
        case '8':
          if (isWeixin()) {
            if (items.liveroom_qrcode_url) {
              _this.liveroom_qrcode_url = items.liveroom_qrcode_url
            }
          } else {
            _this.$toast('请前往微信搜索小程序「创客云商可丽金官方」')
          }
          break
        case '12':
          /**没有id，跳转后页面显示不对,可直接配链接 */
          // _this.$router.push('/actintroduce')
          break
        case '13':
          /**没有id，跳转后页面显示不对,可直接配链接 */
          // _this.$router.push('/giftbagproduct')
          break
        case '14':
          $App.goNewproducthome()
          break
        case '17':
          $App.goCommunity(1, {}, _this)
          break
        case '18':
          /**个人信息，缺app交互 */
          $App.goUserinfo()
          break
        case '19':
          $App.goCommunity(3, {}, _this)
          break
        case '21': // 益司轻新品体验官打卡
          $App.argStaticLink('/static/wx/html/fatLossCheckin/index.html?actid=' + items.ad_target)
          break
        case '22':
          $App.goChannelIndex(items.ad_target)
          break
        case '23':
          $App.goCategroy('navid=0&type=inside')
          break
        case '24':
          if (items.ad_target) {
            $App.goCategroy('channelid=' + items.ad_target.split('_')[0] + '&sortid=' + items.ad_target.split('_')[1])
          }
          break
      }
    }
  })
}

function goXcxCreateBtnFn(_this, type) {
  _this.$nextTick(function () {
    var slideClXcx = document.getElementsByClassName('slide_cl_xcx')
    for (var i = 0; i < slideClXcx.length; i++) {
      if (
        slideClXcx[i].attributes.path.value &&
        slideClXcx[i].innerHTML.indexOf('wx-open-launch-weapp') < 0
      ) {
        var script = document.createElement('script')
        script.type = 'text/wxtag-template'
        script.text = `<div style="width: ${slideClXcx[i].clientWidth}px; height: ${slideClXcx[i].clientHeight}px" class="box"></div>`
        slideClXcx[i].innerHTML = `<wx-open-launch-weapp
                      style="display:block; width:100%;height:100%;"
                      id="launch-btn${i}"
                      username="${slideClXcx[i].attributes.username.value}"
                      path="${slideClXcx[i].attributes.path.value}"
                    >${script.outerHTML}</wx-open-launch-weapp>`
        var btn = document.getElementById(`launch-btn${i}`)
        btn.addEventListener('launch', function (e) {
          if (type == 'index') {
            browHistory({
              page: 'index', // 首页 index  账单yearbill
              toappid: 6,
              topage: 'livelist' // 首页 index  账单yearbill 直播列表 livelist 直播间 live
            })
          }
        })
        btn.addEventListener('error', function (e) {
          console.log('fail', e.detail)
        })
      }
    }
  })
}

// 获取app->web 的传参
function webview_dataFn(callback) {
  return new Promise((resolve, reject) => {
    if (checkAgent() == 'ios' || checkAgent() == 'pc') {
      window.addEventListener('message', function (msg) {
        // console.log(msg.data);
        webview_data = JSON.parse(msg.data)
        resolve()
        // 如果需要获取msg里面的值。需要msg.data。
        // 当时这个坑卡了好久，因为不方便查看msg里面的东西，直接用msg.是获取不到东西的。
        // 还有，记住使用  JSON.parse(msg.data)  才能获取到你的东西!!!
      })
    } else {
      document.addEventListener('message', function (msg) {
        // console.log(msg.data);
        webview_data = JSON.parse(msg.data)
        resolve()
        // 如果需要获取msg里面的值。需要msg.data。
        // 当时这个坑卡了好久，因为不方便查看msg里面的东西，直接用msg.是获取不到东西的。
        // 还有，记住使用  JSON.parse(msg.data)  才能获取到你的东西!!!
      })
    }
    if (typeof callback == 'function') {
      callback()
    }
  })
}
// 新人有礼接口
function newuserFn(callback) {
  var url = $ajax.getNewUserGiftInfo_URL
  customRequestAjax(url).then((res) => {
    if (typeof callback == 'function') {
      callback(res.data)
    }
  })
}
/**
 * 在添加订单前执行的操作
 * 将商店确认结果存储到localStorage，并清除sessionStorage中的一些选择信息
 * @param {Object} shopConfirmResult - 商店确认的结果对象，将被存储到localStorage中
 */
function before_addOrder(shopConfirmResult) {
  // 将shopConfirmResult对象序列化后，保存至localStorage中
  localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
  // 清除sessionStorage中与选择有关的信息
  sessionStorage.removeItem('choose_integral')
  sessionStorage.removeItem('choose_coupon')
  sessionStorage.removeItem('choose_product')
  sessionStorage.removeItem('oversea_List')
}

function download_dialog(that, obj) {
  that.$dialog
    .confirm({
      // title: '签到成功',
      message: obj && obj.msg ? obj.msg : '订单内含有跨境商品，请前往创客云商APP下单',
      confirmButtonText: obj && obj.btntxt ? obj.btntxt : '立即前往',
      className: 'collect_button_alert',
      cancelButtonColor: '#FC0324',
      confirmButtonColor: '#FFFCFC',
      closeOnPopstate: true
    })
    .then(function () {
      // 点击确认按钮
      window.location = downloadpath
    })
    .catch(function () {
      // on cancel
    })
}

function discernFunc(addressDetail, callback1, callback2) {
  if ((addressDetail.indexOf('省市') == -1 && addressDetail.indexOf('超市') == -1 && addressDetail.indexOf('市场') == -1 && (addressDetail.indexOf('省') != -1 || addressDetail.indexOf('市') != -1))
    || (addressDetail.indexOf('省自治州') == -1 && (addressDetail.indexOf('省') != -1 || addressDetail.indexOf('自治州') != -1))
    || (addressDetail.indexOf('省区') == -1 && addressDetail.indexOf('小区') == -1 && addressDetail.indexOf('校区') == -1 && (addressDetail.indexOf('省') != -1 ))
    || (addressDetail.indexOf('省县') == -1 && (addressDetail.indexOf('省') != -1 ))
    || (addressDetail.indexOf('省镇') == -1 && (addressDetail.indexOf('省') != -1 ))
    || (addressDetail.indexOf('市区') == -1 && addressDetail.indexOf('小区') == -1 && addressDetail.indexOf('校区') == -1 && addressDetail.indexOf('超市') == -1 && addressDetail.indexOf('市场') == -1 && (addressDetail.indexOf('市') != -1 ))
    || (addressDetail.indexOf('市县') == -1 && addressDetail.indexOf('超市') == -1 && addressDetail.indexOf('市场') == -1 && (addressDetail.indexOf('市') != -1 ))
    || (addressDetail.indexOf('市镇') == -1 && addressDetail.indexOf('超市') == -1 && addressDetail.indexOf('市场') == -1 && (addressDetail.indexOf('市') != -1 ))
    || (addressDetail.indexOf('自治州市') == -1 && addressDetail.indexOf('超市') == -1 && addressDetail.indexOf('市场') == -1 && (addressDetail.indexOf('自治州') != -1 ))
    || (addressDetail.indexOf('自治州区') == -1 && addressDetail.indexOf('小区') == -1 && addressDetail.indexOf('校区') == -1 && (addressDetail.indexOf('自治州') != -1 ))
    || (addressDetail.indexOf('自治州县') == -1 && (addressDetail.indexOf('自治州') != -1 ))
    || (addressDetail.indexOf('自治州镇') == -1 && (addressDetail.indexOf('自治州') != -1 ))
    || addressDetail.indexOf('自治区') != -1
    || addressDetail.indexOf('北京市') != -1
    || addressDetail.indexOf('上海市') != -1
    || addressDetail.indexOf('天津市') != -1
    || addressDetail.indexOf('重庆市') != -1) {
    if (typeof callback1 == 'function') callback1()
  } else {
    if (typeof callback2 == 'function') callback2()
  }
}
function errorHeadImgFunc(event, errorHeadImg) {
  let img = event.srcElement
  img.src = errorHeadImg
  img.onerror = null
}
// 截流函数
function throttle(func, limit) {
  let inThrottle
  return function () {
    const args = arguments
    const context = this
    if (!inThrottle) {
      func.apply(context, args)
      inThrottle = true
      setTimeout(() => (inThrottle = false), limit)
    }
  }
}
function dateFormat(time, type) {
  let datestr = ''
  switch (type) {
    case 'year':
      datestr = new Date(time).getFullYear() // 年
      break
    case 'month':
      datestr = new Date(time).getMonth() + 1 // 月
      break
    case 'day':
      datestr = new Date(time).getDate() // 日
      break
    case 'hours':
      datestr = new Date(time).getHours() // 时
      break
    case 'min':
      datestr = new Date(time).getMinutes() // 分
      break
    case 'second':
      datestr = new Date(time).getSeconds() // 秒
      break
  }
  return datestr
}
// 获取服务器时间
function getServerDate() {
  if (navigator.onLine) {
    if (window.XMLHttpRequest) {
      var xhr = new XMLHttpRequest()
      xhr.open('GET', '/', false)
      xhr.send(null)
      return new Date(xhr.getResponseHeader('Date'))
    } else {
      console.log('window.XMLHttpRequest=undefined，请升级当前浏览器版本')
      return new Date()
    }
  } else {
    console.log('请检查当前网络')
    return new Date()
  }
}
export {
  wxConfig,
  isWeixin,
  weChatAuthorization,
  setCookie,
  getCookie,
  deleteCookie,
  clearAllCookie,
  browHistory,
  checkAgent,
  random_string,
  encryption,
  unencryption,
  fenxiang,
  Base64,
  kefu,
  qrcodeKefuLimits,
  getQueryString,
  appid,
  wxAjaxData,
  basepath,
  isApp,
  formateName,
  formateMobile,
  copyContentH5,
  handleFocus,
  handleblur,
  unique,
  uniqueArray,
  appidFn,
  exclusiveidFn,
  meetingidFn,
  publicParams,
  isWx,
  parametersCombine,
  dateFn,
  requestSubscribeMessage,
  dateStrFn,
  buriedpointpath,
  buriedPoint,
  identity,
  commonburiedPoint,
  clickburiedPoint,
  getlinkidFn,
  clone,
  cartNum,
  pageStatus,
  goMini,
  downloadpath,
  ckeckgraphic,
  downloadshoppath,
  getVipLevel,
  datacenterpath,
  popType,
  clearPopCache,
  bannerClick,
  goXcxCreateBtnFn,
  webview_data,
  webview_dataFn,
  newuserFn,
  download_dialog,
  discernFunc,
  pointParams,
  objectDecode,
  before_addOrder,
  // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
  cosuploadpath,
  cosaccesspath,
  dateFormat,
  // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End,
  throttle,
  errorHeadImgFunc,
  getServerDate
}



// WEBPACK FOOTER //
// ./src/assets/common/js/config.js